import { render, staticRenderFns } from "./UiTable.vue?vue&type=template&id=592b9901&lang=pug"
import script from "./UiTable.vue?vue&type=script&lang=js"
export * from "./UiTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports